<template>
    <div v-if="wantsDelivery">
        <slot><p><strong>Lieferadresse</strong></p></slot>
        <p>
            {{ contactPerson }}<br>
            <span v-if="deliveryAddressObject.company">
                {{ deliveryAddressObject.company ? deliveryAddressObject.company : subscription.details.consumer.company }}<br>
                    </span>
            {{ deliveryAddressObject.street }}<br>
            {{ deliveryAddressObject.postal_code }} {{ deliveryAddressObject.city }}
        </p>
    </div>
</template>

<script>
    export default {
        name: "DeliveryAddressExistingCustomer",
        props: {
            subscription: {
                type: Object,
                required: true
            },
            consumer: {
                type: Object,
                required: true
            },
            isCheckoutOverview: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        computed: {
            deliveryAddressObject: function () {
                if (this.subscription.delivery_address !== null) {
                    return this.subscription.delivery_address;
                } else {
                    if (typeof this.subscription.details.deliveryAddress !== 'undefined') {
                        return this.subscription.details.deliveryAddress;
                    } else {
                        return this.subscription.details.address;
                    }
                }
            },
            contactPerson() {
                if (this.deliveryAddressObject) {
                    let contactPerson = this.deliveryAddressObject.contact_person;
                    contactPerson = JSON.parse(JSON.stringify(contactPerson));
                    if (contactPerson !== null || !this.isEmpty(contactPerson)) {

                        return contactPerson;
                    }
                }

                return this.consumer.first_name + " " + this.consumer.last_name;
            },
            wantsDelivery() {
                if (this.isCheckoutOverview) {
                    if (this.subscription.details !== null) {
                        return this.subscription.details.deliveryMethod === 'delivery';
                    }
                    return true;
                }
                return true;
            }
        },
        methods: {
            isEmpty(obj) {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
